import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useApp } from './context/AppContext';
import Sidebar from './components/Sidebar';
import Header  from './components/Header';
import Login   from './pages/Login/Login';
import CompanyRegistration from './pages/Registration/CompanyRegistration';
import AccountSetup from './pages/Registration/AccountSetup';
import ForgotPassword from './pages/Login/ForgotPassword';
import CreatePassword from './pages/Registration/CreatePassword';

import Dashboard        from './pages/Dashboard/Dashboard';
import Pump             from './pages/Pump/Pump';
import PumpSetup        from './pages/PumpSetup/PumpSetup';
import NozzleConfig     from './pages/NozzleConfig/NozzleConfig';
import Master           from './pages/Master/Master';
import Tank             from './pages/Tank/Tank';

import Customer         from './pages/Customer/Customer';
import Entry            from './pages/Entry/Entry';
import ClosingStock     from './pages/ClosingStock/ClosingStock';
import Sale             from './pages/Sale/Sale';
import SaleReturn       from './pages/SaleReturn/SaleReturn';
import MeterReading     from './pages/MeterReading/MeterReading';
import LubeSales        from './pages/LubeSales/LubeSales';
import CreditSale       from './pages/CreditSale/CreditSale';
import SaleBillLubeGST  from './pages/SaleBillLubeGST/SaleBillLubeGST';
import DailyReceipt     from './pages/DailyReceipt/DailyReceipt';
import ItemLoss         from './pages/ItemLoss/ItemLoss';
import BillReceipt      from './pages/BillReceipt/BillReceipt';
import Purchase         from './pages/Purchase/Purchase';
import PurchaseEntry    from './pages/PurchaseEntry/PurchaseEntry';
import PurchaseReturn   from './pages/PurchaseReturn/PurchaseReturn';
// import Dip              from './pages/Dip/Dip';
// import DipChart         from './pages/DipChart/DipChart';
import Banks from './pages/Banks/Banks';
// import Ledgers from './pages/Ledgers/Ledger';
import Payments         from './pages/Payments/Payments';

import './styles/App.css';

function PageContent({ page, user }) {
  switch (page) {
    case 'Dashboard':        return <Dashboard user={user} />;
    case 'Pump':
    case 'PumpList':         return <Pump user={user} />;
    case 'PumpSetup':        return <PumpSetup user={user} />;
    case 'NozzleConfig':     return <NozzleConfig user={user} />;
    case 'Banks':            return <Banks user={user} />;
    // case 'Ledgers':          return <Ledgers user={user} />;
    case 'Master':
    case 'Product':          return <Master user={user} />;
    case 'Tank':             return <Tank user={user} />;

    case 'Customer':         return <Customer user={user} />;
    case 'Entry':
    case 'OpeningStock':     return <Entry user={user} />;
    case 'ClosingStock':     return <ClosingStock user={user} />;
    case 'MeterReading':     return <MeterReading user={user} />;
    case 'Sale':
    case 'SaleList':         return <Sale user={user} />;
    case 'SaleReturn':       return <SaleReturn user={user} />;
    case 'LubeSales':        return <LubeSales user={user} />;
    case 'CreditSale':       return <CreditSale user={user} />;
    case 'SaleBillLubeGST':  return <SaleBillLubeGST user={user} />;
    case 'DailyReceipt':     return <DailyReceipt user={user} />;
    case 'ItemLoss':         return <ItemLoss user={user} />;
    case 'BillReceipt':      return <BillReceipt user={user} />;
    case 'Purchase':
    case 'PurchaseOrder':    return <Purchase user={user} />;
    case 'PurchaseEntry':    return <PurchaseEntry user={user} />;
    case 'PurchaseReturn':   return <PurchaseReturn user={user} />;
    case 'Payments':         return <Payments user={user} />;
    // case 'Dip':
    // case 'DipReading':       return <Dip user={user} />;
    // case 'DipChart':         return <DipChart user={user} />;
    default:
      return (
        <div style={{background:'white', borderRadius:6, padding:48, textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
          <h2 style={{color:'var(--primary)', marginBottom:8}}>{page}</h2>
          <p style={{color:'var(--text-secondary)'}}>This module is coming soon.</p>
        </div>
      );
  }
}

export default function App() {
  const { state, dispatch } = useApp();
  const user = state.user;

  const [activePage, setActivePage] = useState(() => {
    return sessionStorage.getItem('activePage') || 'Dashboard';
  });

  const handleLogin = (userData) => {
    dispatch({ type: 'LOGIN', payload: userData });
    sessionStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    setActivePage('Dashboard');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('activePage');
  };

  const handleSidebarPage = (page) => {
    setActivePage(page);
    sessionStorage.setItem('activePage', page);
  };

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Login onLogin={handleLogin} />} />
        <Route path="/register-company" element={<CompanyRegistration />} />
        <Route path="/account-setup" element={<AccountSetup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <div className="app-container">
      <Sidebar activePage={activePage} setActivePage={handleSidebarPage} />
      <div className="main-content">
        <Header user={user} onLogout={handleLogout} />
        <div className="page-content">
          <PageContent page={activePage} user={user} />
        </div>
      </div>
    </div>
  );
}
